export const  companyName = "Namma Family Group";
   
export const smsApiKey = "ffcfd5ae750da057a7d9b6bd2bb2a33a";

export const senderId = "NFAMLY";

export const templateId = "1707176743113682878";

export const smsContent  = ""

